
import * as THREE from "three";

// Utility funkcije za rad s globe komponentom
export const getPointPosition = (lat: number, lng: number, radius: number): THREE.Vector3 => {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lng + 180) * (Math.PI / 180);

  const x = -(radius * Math.sin(phi) * Math.cos(theta));
  const z = radius * Math.sin(phi) * Math.sin(theta);
  const y = radius * Math.cos(phi);

  return new THREE.Vector3(x, y, z);
};

// Helper function to precisely convert latitude/longitude to 3D coordinates
export const latLongToVector3 = (lat: number, lon: number, radius: number): [number, number, number] => {
  // Convert latitude and longitude from degrees to radians
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lon + 180) * (Math.PI / 180);
  
  // Calculate the position on the sphere
  const x = -(radius * Math.sin(phi) * Math.cos(theta));
  const z = radius * Math.sin(phi) * Math.sin(theta);
  const y = radius * Math.cos(phi);
  
  return [x, y, z];
};

export const createGlobeTexture = async (textureUrl: string): Promise<THREE.Texture> => {
  const textureLoader = new THREE.TextureLoader();
  return new Promise((resolve, reject) => {
    textureLoader.load(textureUrl, resolve, undefined, reject);
  });
};

export const createGlowEffect = (size: number): THREE.Mesh => {
  const glowGeometry = new THREE.SphereGeometry(size * 1.2, 64, 64);
  const glowMaterial = new THREE.MeshBasicMaterial({
    color: 0x00ffff,
    transparent: true,
    opacity: 0.1,
    side: THREE.BackSide,
  });
  
  return new THREE.Mesh(glowGeometry, glowMaterial);
};

// Generate a spiral pattern around the globe for particles
export const generateSpiralParticles = (count: number, size: number): [number, number, number][] => {
  const points: [number, number, number][] = [];
  const phi = Math.PI * (3 - Math.sqrt(5)); // Golden angle
  
  for (let i = 0; i < count; i++) {
    const y = 1 - (i / (count - 1)) * 2; // y goes from 1 to -1
    const radius = Math.sqrt(1 - y * y); // radius at y
    
    const theta = phi * i; // Golden angle increment
    
    const x = Math.cos(theta) * radius;
    const z = Math.sin(theta) * radius;
    
    points.push([x * size, y * size, z * size]);
  }
  
  return points;
};
